<template>
  <div class="card-content">
    <div id="menu-tab">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('米水比例')" name="RiceRatio">
        </el-tab-pane>
        <el-tab-pane :label="$t('小贴士')" name="RiceScore">
        </el-tab-pane>
      </el-tabs>
    </div>
    <keep-alive>
      <component :is="activeName" :externalHeight="tabMenuHeight" />
    </keep-alive>
  </div>
</template>

<script>
import RiceRatio from "@/components/rice/RiceRatio";
import RiceScore from "@/components/rice/RiceScore";
export default {
  name: "RiceList",
  components: {RiceScore, RiceRatio},
  data() {
    return {
      activeName: "RiceRatio",
      tabMenuHeight: 0
    }
  },
  mounted() {
    this.handleResizeTableHeight();
  },
  methods: {
    // 监听表格内容高度
    handleResizeTableHeight() {
      this.$nextTick(() => {
        const wrapper = document.querySelector("#menu-tab");
        this.tabMenuHeight = (wrapper?.clientHeight || 0) + 40;
      })
    },
  }
}
</script>

<style scoped>

.card-content {
  background: #ffffff;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 12px;
}


</style>
